/**
 * Alpha search before-typing panel (Search Alpha/Beta A/B test). Loaded with the shared core (search-alpha.js)
 * only when the theme setting `search_variant` is 'alpha' (see layout/theme.liquid). Alpha's own copy of
 * search-beta.js, so either variant can change or be removed without touching the other.
 *
 * - Before the shopper types, the header dropdown shows recent searches, trending searches and the newest blog
 *   posts (snippets/search-alpha-default.liquid). The core fires `search-alpha:empty` on the form whenever the
 *   field is focused or cleared below 3 characters; this file fills the dropdown from the template then.
 * - Recent searches are the last 3 searches, kept in this browser (localStorage).
 */

(function () {
  const HISTORY_KEY = 'fbc_search_alpha_history';
  const HISTORY_LIMIT = 3;
  const MIN_TERM_LENGTH = 3;
  const SEARCH_SUFFIX = '&type=product&options%5Bprefix%5D=last';
  const rootUrl = window.Shopify?.routes?.root || '/';

  const readHistory = () => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(HISTORY_KEY) || '[]');
      return Array.isArray(saved) ? saved.filter((term) => typeof term === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const saveTerm = (rawTerm) => {
    const term = (rawTerm || '').trim();
    if (term.length < MIN_TERM_LENGTH || term.includes('tag:')) return;

    const history = readHistory().filter((saved) => saved.toLowerCase() !== term.toLowerCase());
    history.unshift(term);

    try {
      window.localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, HISTORY_LIMIT)));
    } catch (error) {
      // Storage can be unavailable (private mode, blocked site data); history is optional.
    }
  };

  // A search results page visit counts as a search, however the shopper got there (submit, View all, history).
  const pageInput = document.querySelector('[search-section-form-input]');
  if (pageInput) saveTerm(pageInput.value);

  const headerSearch = document.querySelector('[search-alpha]');
  const defaultTemplate = headerSearch?.querySelector('template[search-alpha-default]');
  const recentItemTemplate = headerSearch?.querySelector('template[search-alpha-recent-item]');
  const searchForm = headerSearch?.querySelector('form');
  const searchInput = searchForm?.querySelector('[header-search-form-input]');
  const resultsContainer = searchForm?.querySelector('.predictive-search');
  if (!defaultTemplate || !recentItemTemplate || !searchInput || !resultsContainer) return;

  const renderDefault = () => {
    if (searchInput.value.trim().length >= MIN_TERM_LENGTH) return;

    const panel = defaultTemplate.content.cloneNode(true);
    const recent = panel.querySelector('[search-alpha-recent]');
    const recentList = panel.querySelector('[search-alpha-recent-list]');
    const history = readHistory();

    history.forEach((term) => {
      const item = recentItemTemplate.content.cloneNode(true);
      item.querySelector('[search-alpha-recent-link]').href = `${rootUrl}search?q=${encodeURIComponent(term)}${SEARCH_SUFFIX}`;
      item.querySelector('[search-alpha-recent-term]').textContent = term;
      recentList.appendChild(item);
    });
    if (recent && history.length > 0) recent.hidden = false;

    resultsContainer.replaceChildren(panel);
  };

  searchForm.addEventListener('search-alpha:empty', renderDefault);

  // Also fill it the moment the search panel opens (the header toggle flips aria-expanded), not only on focus.
  new MutationObserver(() => {
    if (headerSearch.getAttribute('aria-expanded') === 'true') renderDefault();
  }).observe(headerSearch, { attributes: true, attributeFilter: ['aria-expanded'] });

  // Remember the words when the shopper leaves the dropdown for a result or the results page.
  searchForm.addEventListener('submit', () => saveTerm(searchInput.value));
  resultsContainer.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('a[href]') && !event.target.closest('[search-alpha-recent-link], [search-alpha-trending]')) {
      saveTerm(searchInput.value);
    }
  });
})();
